import { defineStore } from 'pinia';
import { useIndexStore } from './IndexStore';
import { LANG_FRENCH } from '@/constants';
import DestinationService from '@/service/DestinationService';

export const useDestinationStore = defineStore('destinationStore', {
  state: () => ({
    destinationsMultiple: [],
    destinationsOnlyHotel: [],
    destinationsMultipleOnlyAir: [],
    destinationRequote: {},
    durationRequote: '',
    destinationByCode: {},
    destinationSelected: {}
  }),
  getters: {
    selectDestinationsMultiple: (state) => state.destinationsMultiple,
    selectDestinationsOnlyHotel: (state) => state.destinationsOnlyHotel,
    selectDestinationsMultipleOnlyAir: (state) => state.destinationsMultipleOnlyAir,
    selectDestinationRequote: (state) => state.destinationRequote,
    selectDurationRequote: (state) => state.durationRequote,
    selectDestinationByCode: (state) => state.destinationByCode,
    selectDestinationSelected: (state) => state.destinationSelected
  },
  actions: {
    getDestinationByCode(code) {
      this.destinationsMultiple.forEach((des) => {
        des.forEach((d) => {
          d.items.forEach((item) => {
            if (+item.code === +code) {
              this.destinationByCode = item;
            }
          });
        });
      });
    },
    updateDurationRequote(payload) {
      this.durationRequote = payload;
    },
    updateDestinationRequote(payload) {
      this.destinationRequote = payload;
    },
    updateDestinationsMultiple({ destinations, index }) {
      this.destinationsMultiple[index] = destinations;
    },
    updateDestinationsOnlyHotel(payload) {
      this.destinationsOnlyHotel = payload;
    },
    updateDestinationsMultipleOnlyAir({ destinations, index }) {
      this.destinationsMultipleOnlyAir[index] = destinations;
    },
    updateDestinationSelected(payload) {
      this.destinationSelected = payload;
    },
    getListDestination(listDestinationsId) {
      const destinationService = new DestinationService();
      return destinationService.getDestinations(listDestinationsId);
    },
    async getDestinationsMultiple({ listDestinationsId, index }, language) {
      try {
        const destinationService = new DestinationService();
        const res = await destinationService.getDestinations(listDestinationsId);
        const dataKey = language === LANG_FRENCH ? 'countryFr' : 'country';
        if (res) {
          const destinationsTemp = res.data;
          const destinationsTempNew = destinationsTemp.map((m) => {
            const data = {
              label: m[dataKey],
              items: destinationsTemp.filter((n) => n[dataKey] === m[dataKey])
            };
            return data;
          });
          const setDestinations = [];
          destinationsTempNew.forEach((item1) => {
            if (!setDestinations.filter((item2) => item1.label === item2.label).length) {
              setDestinations.push(item1);
            }
          });
          const payload = {
            destinations: setDestinations,
            index: index
          };
          this.updateDestinationsMultiple(payload);
        }
        return res;
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },
    async getDestinationsOnlyHotel(language) {
      try {
        const destinationService = new DestinationService();
        const res = await destinationService.getDestinationsOnlyHotel();
        const dataKey = language === LANG_FRENCH ? 'countryFr' : 'country';
        if (res) {
          const destinationsTemp = res.data;
          const destinationsTempNew = destinationsTemp.map((m) => {
            const data = {
              label: m[dataKey],
              items: destinationsTemp.filter((n) => n[dataKey] === m[dataKey])
            };
            return data;
          });
          const setDestinations = [...new Set(destinationsTempNew)];
          this.updateDestinationsOnlyHotel(setDestinations);
        }
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },
    async getDestinationsMultipleOnlyAir({ listDestinationsId, index }) {
      try {
        const destinationService = new DestinationService();
        const res = await destinationService.getDestinations(listDestinationsId);
        if (res) {
          const destinationsOnlyAirTemp = res.data;
          const destinationsOnlyAirTempNew = destinationsOnlyAirTemp.map((m) => {
            const data = {
              label: m.country,
              items: destinationsOnlyAirTemp.filter((n) => n.country === m.country)
            };
            return data;
          });
          const setDestinationsOnlyAir = [];
          destinationsOnlyAirTempNew.forEach((item1) => {
            if (!setDestinationsOnlyAir.filter((item2) => item1.label === item2.label).length) {
              setDestinationsOnlyAir.push(item1);
            }
          });
          const payload = {
            destinations: setDestinationsOnlyAir,
            index: index
          };
          this.updateDestinationsMultipleOnlyAir(payload);
        }
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },
    async getDestinationRequote(code) {
      const destinationService = new DestinationService();
      const res = await destinationService.getDestinationsOnlyHotel();
      try {
        const filterDestination = res.data.filter((r) => {
          return +r.code === +code;
        });
        this.updateDestinationRequote(filterDestination);
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },
    async getDurationRequoteByDestination(duration, destination) {
      if (destination.durations) {
        const filterDuration = destination.durations.filter((d) => {
          if (d === duration) {
            return duration;
          }
        });
        this.updateDurationRequote(filterDuration);
      }
    },
    addDestinationGroup(body) {
      const destinationService = new DestinationService();
      destinationService.addDestinationsGroup(body);
    },
    async getSeasonalCalendar(body) {
      const destinationService = new DestinationService();
      const res = await destinationService.getSeasonalCalendar(body);
      return res?.data;
    }
  }
});
